'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('div', {});

var FillEmptySpace = _react2['default'].createClass({
    displayName: 'FillEmptySpace',


    propTypes: {
        footerClass: _react2['default'].PropTypes.string //NOTE: If another React component is leveraging this component, include a unique key for each generated message. See MultiSelect for more info.
    },

    expandSpace: function expandSpace() {

        var footerClass = this.props.footerClass || '.m-footer';

        var thisNode = $(_reactDom2['default'].findDOMNode(this));
        var windowHeight = $(window).height();
        var componentYPos = thisNode.offset().top;
        var footerHeight = $(footerClass).outerHeight();
        var twitterHeight = $('.m-footer') && $('.m-twitter').outerHeight(); // this should probably be passed in as a prop for more flexibility like the line above
        var spaceToFill = windowHeight - componentYPos - footerHeight - twitterHeight - 5;
        thisNode.height(spaceToFill);
    },

    componentDidMount: function componentDidMount() {

        var self = this;
        this.expandSpace();
        if (window) {
            window.onresize = function (event) {
                self.expandSpace();
            };
        }
        $(document).bind('repositionFooter', function () {
            this.expandSpace();
        }.bind(this));
    },
    render: function render() {
        return _ref;
    }
});
module.exports = FillEmptySpace;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/fill-empty-space.jsx
 ** module id = 615
 ** module chunks = 0
 **/